module.exports = __webpack_public_path__ + "img/bn.d5a2d918.svg";